import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SettingsService } from '@app/core/config/settings.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'injectUrl',
  pure: false
})
export class InjectUrlPipe implements PipeTransform {
  private readonly settingService = inject(SettingsService);
  private readonly translate = inject(TranslateService);
  private readonly sanitizer = inject(DomSanitizer);

  msg     : string | null = null;
  result ?: string;

  transform(msg: string, ...urlKeys: string[]): any  {
    if (this.msg === msg) return this.result;

    let suffix = '.' + this.translate.getCurrentLang();
    let urls = urlKeys.map((key: string) => this.settingService.get(key + suffix) ?? '');
    let result = this.injectLinks(msg, urls);

    this.msg = msg;
    this.result = result;

    return result;
  }

  injectLinks(msg: string, urls: string[]): string {
    // sanitize strings
    msg = this.sanitizer.sanitize(SecurityContext.HTML, msg) ?? '';
    urls = urls.map(url => this.sanitizer.sanitize(SecurityContext.URL, url) ?? '');

    let result: string[] = [];
    let closeLink = false;
    msg.split(/\|/).forEach( (str, index) => {
      if (closeLink) {
        closeLink = false;
        result.push('</a>');
      } else if (index > 0 && urls.length) {
        closeLink = true;
        result.push(
          '<a href="',
          urls.shift() ?? '',
          '" target="_blank" class="icon icon--after icon--external">',
        );
      }
      result.push(str);
    });
    if (closeLink) result.push('</a>');
    return result.join('');
  }
}
